export enum ExamType {
  Standard = 0,
  Retake = 1,
  CarryForward = 2,
  RetakeCarryForward = 3,
}

export function GetExamTypeName(isRetake : boolean, isCarryForward : boolean) : string
{
  return isRetake && isCarryForward
              ? 'Carry Forward/Retake'
              : isRetake
              ? 'Retake'
              : isCarryForward
              ? 'Carry Forward'
              : 'Standard'
}
